<template>
  <v-card
    v-if="showSection"
    :class="classNames"
    width="100%"
  >
    <v-row
      noGutters
      class="row--wrapper"
    >
      <v-col
        cols="auto"
      >
        <div
          :class="[
            mutableValue || !displayShowHideSection
              ? 'icon--container'
              : 'icon--container icon--container__disabled',
          ]"
        >
          <TreeCardIcon
            v-if="treeIcon.show"
            :src="treeIcon.icon"
            :alt="treeIcon.alt"
          />
          <v-icon
            v-else
            color="#fff"
          >
            {{ iconName }}
          </v-icon>
        </div>
      </v-col>
      <v-col
        lg="auto"
        md="auto"
        sm="auto"
        cols="auto"
      >
        <div
          v-if="sectionTitle"
          class="title--container"
        >
          <h1 class="title--section">
            {{ sectionTitle }}
          </h1>
        </div>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
      >
        <div
          v-if="displayShowHideSection"
          class="switch--container"
        >
          <v-switch
            v-model="mutableValue"
            inset
            hideDetails
            class="switch--report"
            color="#26384B"
            :disabled="isDisabled"
            @change="$emit('showHideSection', mutableValue, sectionName)"
          />
        </div>
      </v-col>
    </v-row>
    <slot name="child" />
  </v-card>
</template>

<script>

import TreeCardIcon from '@/components/component/icons/TreeCardIcon.vue';

export default {
    components: {
        TreeCardIcon,
    },
    props: {
        iconName: {
            type: String,
            default: '',
        },
        isLast: {
            type: Boolean,
            default: false,
        },
        sectionName: {
            type: String,
            default: '',
        },
        showReportSection: {
            type: Boolean,
            default: true,
        },
        displayShowHideSection: {
            type: Boolean,
            default: true,
        },
        sectionTitle: {
            type: String,
            default: '',
        },
        containerClass: {
            type: String,
            default: '',
        },
        showSection: {
            type: Boolean,
            default: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mutableValue: this.showReportSection,
        };
    },
    computed: {
        classNames() {
            const firstClass = this.isLast ? 'card--container lastCard' : 'card--container';
            const classes = [firstClass];
            if (this.containerClass) {
                classes.push(this.containerClass);
            }
            return classes;
        },
        treeIcon() {
            return {
                icon: `/assets/${this.iconName}White.svg`,
                alt: this.iconName,
                show: ['flowMeter', 'productLevel', 'analysis', 'massBalance'].includes(this.iconName),
            };
        },
    },
    watch: {
        showReportSection: {
            handler(val) {
                this.mutableValue = val;
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.row--wrapper {
  position: absolute;
  height: 36px;
  width: 100%;
  top: -18px;
  left: 0px;
  margin: 0px;
  padding-left: 15px;
}
.card--container {
  max-width: 100%;
  height: auto;
  margin-bottom: 40px;
  position: relative;
  padding: 20px;
  padding-bottom: 0px;
  border: 1px solid rgba(38, 56, 75, 0.50);;
}

.lastCard {
  margin-bottom: 0px;
}

.icon--container {
  background: #26384b;
  width: 40px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #26384b;
}
.title--container {
  background: white;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 15px;
    .title--section {
      color: #26384B;
      font-size: 15px;
      font-weight: 500;
    }
}

.icon--container__disabled {
  background: #a1a9b1;
  border: 1px solid #a1a9b1;
}
.switch--container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 100% !important;
  max-height: 36px !important;
  border: none !important;
}

.switch--report {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
</style>
